// Utilities
import axios from 'axios';

const state = {
  obj: 'working',
  new_document_object: {},
  error: '',

  margin: null,
};

const mutations = {
  SET_NEW_DOCUMENT(state, payload) {
    state.new_document_object = payload;
  },
  Auth_error(state, payload) {
    state.error = "Ce numéro de document n'existe pas";
  },
};

const actions = {
  getHomePage({ commit }, Infos) {
    const datacollect = {
      page: Infos,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/KJ498UFHF237YGFFY28F/getHomePage',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  deleteCarousel({ commit }, Infos) {
    const datacollect = {
      _id: Infos._id,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/KJ498UFHF237YGFFY28F/deleteCarousel',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  deleteHomePageProject({ commit }, Infos) {
    const datacollect = {
      _id: Infos._id,
    };

    return new Promise((resolve, reject) => {
      axios({
        url: '/api/KJ498UFHF237YGFFY28F/deleteHomePageProject',
        method: 'POST',
        data: datacollect,
      })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
